module.exports = __webpack_public_path__ + "static/media/logo-black.8eee0cfd.svg";